import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Typo } from '../../../../ui';
import { shadeColor } from '../../../../ui/theme/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px 20px;
  background: ${({ $bgColor }) => $bgColor};
  border: 2px dashed ${({ $borderColor }) => $borderColor};
  border-radius: 8px;
  min-height: 120px;
  width: 100%;
  text-align: center;
`;

/**
 * EmptyStatePlaceholder component - Shows placeholder when module has no content
 *
 * @param {Object} props
 * @param {string} props.moduleType - The type of module (for translation key)
 * @param {React.Component} props.IconComponent - The icon component to render
 * @param {string} props.themeColor - Theme color for styling
 */
const EmptyStatePlaceholder = ({ moduleType, IconComponent, themeColor }) => {
  const { t } = useTranslation();

  return (
    <Container $bgColor={shadeColor(themeColor, 0.97)} $borderColor={shadeColor(themeColor, 0.7)}>
      <IconComponent size='medium' color={themeColor} />
      <Typo.TextTitle>{t(`editCourse.emptyState.${moduleType}`)}</Typo.TextTitle>
      <Typo.SmallText>{t('editCourse.emptyState.description')}</Typo.SmallText>
    </Container>
  );
};

export default EmptyStatePlaceholder;
